import ImageResults from "./ImageResults";

export default ImageResults;
